import { Helmet } from "react-helmet-async"
import { TTravelActivity } from "../../../../TravelActivities"
import { useOutletContext } from "react-router"
import { ServicesDetails } from "../../../../TransportServices"
import { useGetBackUrlFromLocation } from "@sembark-travel/ui/router"

export default function TravelActivityBasicDetailsPage() {
	const { travelActivity, revalidate } = useOutletContext<{
		travelActivity: TTravelActivity
		revalidate: () => void
	}>()
	const backUrl = useGetBackUrlFromLocation()
	const array = backUrl?.split(/[?&]/)
	return (
		<>
			<Helmet>
				<title>Travel Activity Details</title>
			</Helmet>
			<ServicesDetails
				services={travelActivity.ticket_types}
				mutate={revalidate}
				isDisable={array?.includes("disabled_only=1") || false}
				type="activity"
				heading="Tickets/Packages"
			/>
		</>
	)
}
